import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import { generalQuoteTemplate, quoteInquiryTemplate } from './emailTemplates';
import { completeFareTable } from './completeFareData';

import './App.css';

// EmailJS 초기화
emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);



// 정밀 운임표 데이터 (20km~600km, 1km 단위, 차종별 운임 - 단위: 만원)
// 마크다운 파일 데이터를 기반으로 한 정확한 운임표
const fareTable = {
  20: { '1톤': 4.0, '1.4톤': 5.0, '2.5톤': 7.0, '3.5톤': 8.0, '5톤장': 10.0, '5톤플': 11.0, '5톤축': 12.0, '11톤': 13.0, '18톤': 18.0, '25톤': 20.0, '추레라': 22.0 },
  21: { '1톤': 4.2, '1.4톤': 5.1, '2.5톤': 7.1, '3.5톤': 8.1, '5톤장': 10.0, '5톤플': 11.1, '5톤축': 12.1, '11톤': 13.1, '18톤': 18.1, '25톤': 20.1, '추레라': 22.1 },
  22: { '1톤': 4.4, '1.4톤': 5.2, '2.5톤': 7.2, '3.5톤': 8.2, '5톤장': 10.0, '5톤플': 11.2, '5톤축': 12.2, '11톤': 13.2, '18톤': 18.2, '25톤': 20.2, '추레라': 22.2 },
  23: { '1톤': 4.6, '1.4톤': 5.3, '2.5톤': 7.3, '3.5톤': 8.3, '5톤장': 10.0, '5톤플': 11.3, '5톤축': 12.3, '11톤': 13.3, '18톤': 18.3, '25톤': 20.3, '추레라': 22.3 },
  24: { '1톤': 4.8, '1.4톤': 5.4, '2.5톤': 7.4, '3.5톤': 8.4, '5톤장': 10.0, '5톤플': 11.4, '5톤축': 12.4, '11톤': 13.4, '18톤': 18.4, '25톤': 20.4, '추레라': 22.4 },
  25: { '1톤': 5.0, '1.4톤': 5.5, '2.5톤': 7.5, '3.5톤': 8.5, '5톤장': 10.0, '5톤플': 11.5, '5톤축': 12.5, '11톤': 13.5, '18톤': 18.5, '25톤': 20.5, '추레라': 22.5 },
  26: { '1톤': 5.2, '1.4톤': 5.6, '2.5톤': 7.6, '3.5톤': 8.6, '5톤장': 10.0, '5톤플': 11.6, '5톤축': 12.6, '11톤': 13.6, '18톤': 18.6, '25톤': 20.6, '추레라': 22.6 },
  27: { '1톤': 5.4, '1.4톤': 5.7, '2.5톤': 7.7, '3.5톤': 8.7, '5톤장': 10.0, '5톤플': 11.7, '5톤축': 12.7, '11톤': 13.7, '18톤': 18.7, '25톤': 20.7, '추레라': 22.7 },
  28: { '1톤': 5.6, '1.4톤': 5.8, '2.5톤': 7.8, '3.5톤': 8.8, '5톤장': 10.0, '5톤플': 11.8, '5톤축': 12.8, '11톤': 13.8, '18톤': 18.8, '25톤': 20.8, '추레라': 22.8 },
  29: { '1톤': 5.8, '1.4톤': 5.9, '2.5톤': 7.9, '3.5톤': 8.9, '5톤장': 10.0, '5톤플': 11.9, '5톤축': 12.9, '11톤': 13.9, '18톤': 18.9, '25톤': 20.9, '추레라': 22.9 },
  30: { '1톤': 5.0, '1.4톤': 6.0, '2.5톤': 8.0, '3.5톤': 9.0, '5톤장': 10.0, '5톤플': 12.0, '5톤축': 13.0, '11톤': 14.0, '18톤': 19.0, '25톤': 21.0, '추레라': 23.0 }
};

// completeFareData.js의 운임표를 사용하여 정확한 운임 계산

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/order" element={<OrderFrame />} />
        </Routes>
      </div>
    </Router>
  );
}

// OrderFrame 컴포넌트 수정
function OrderFrame() {
  const [orderStatus, setOrderStatus] = useState('loading');
  // 주문 시스템 URL: 프로덕션에서는 REACT_APP_ORDER_URL(예: https://order.example.com)
  // 개발환경에서는 기본값으로 http://localhost:5173 사용
  const orderBaseUrl = process.env.REACT_APP_ORDER_URL || (window.location.hostname === 'localhost' ? 'http://localhost:5173' : '/order');

  useEffect(() => {
    // order 애플리케이션이 실행 중인지 확인
    const checkOrderApp = async () => {
      try {
        const response = await fetch(orderBaseUrl);
        if (response.ok) {
          setOrderStatus('ready');
        } else {
          setOrderStatus('not-running');
        }
      } catch (error) {
        setOrderStatus('not-running');
      }
    };

    checkOrderApp();
  }, []);

  useEffect(() => {
    // 컴포넌트 마운트 시 body overflow 숨김
    document.body.style.overflow = 'hidden';
    
    // 컴포넌트 언마운트 시 원래대로 복원
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  if (orderStatus === 'loading') {
    return (
      <div style={{width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div style={{textAlign: 'center'}}>
          <div style={{fontSize: '18px', marginBottom: '20px'}}>퀵/일반화물 접수 시스템을 확인하고 있습니다...</div>
        </div>
      </div>
    );
  }

  if (orderStatus === 'not-running') {
    return (
      <div style={{width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div style={{textAlign: 'center'}}>
          <div style={{fontSize: '18px', marginBottom: '20px', color: 'red'}}>주문 시스템이 실행되지 않았습니다.</div>
          <div style={{fontSize: '14px', color: '#666', marginBottom: '20px'}}>
            다음 명령을 실행해주세요:
            <br />
            <code>cd C:\\my-react-app\\order && npm run dev</code>
          </div>
          <button 
            onClick={() => window.location.reload()} 
            style={{padding: '10px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px'}}
          >
            다시 확인
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      width: '100%', 
      height: '100vh', 
      margin: 0, 
      padding: 0, 
      overflow: 'hidden'
    }}>
      <iframe 
        src={orderBaseUrl}
        style={{
          width: '100%', 
          height: '100%', 
          border: 'none',
          margin: 0,
          padding: 0,
          display: 'block'
        }}
        title="퀵/일반화물 접수"
        scrolling="yes"
      />
    </div>
  );
}

function HomePage() {
  const [activeSection, setActiveSection] = useState('home');
  const [showFloatingForm, setShowFloatingForm] = useState(false);
  const [selectedService, setSelectedService] = useState('');

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isTabletOrMobile, setIsTabletOrMobile] = useState(false);
  // 정책 팝업 상태
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isEmailPolicyOpen, setIsEmailPolicyOpen] = useState(false);
  
  // 화면 크기 변경 감지
  useEffect(() => {
    const checkScreenSize = () => {
      setIsTabletOrMobile(window.innerWidth <= 1024);
    };
    
    // 초기 로드 시 체크
    checkScreenSize();
    
    // 리사이즈 이벤트 리스너 추가
    window.addEventListener('resize', checkScreenSize);
    
    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // 카카오맵 초기화
  useEffect(() => {
    if (activeSection === 'company') {
      // 다음 지도 퍼가기 서비스 초기화
      let retryTimer = null;
      let initTimer = null;
      let resizeTimer = null;

      const initDaumRoughMap = () => {
        const container = document.getElementById('daumRoughmapContainer1758086878144');
        if (container && window.daum && window.daum.roughmap && window.daum.roughmap.Lander) {
          try {
            // 기존 지도가 있다면 제거
            container.innerHTML = '';
            
            // 주소 섹션 너비를 기준으로 반응형 크기 계산
            let mapWidthPx;
            const addressSection = document.querySelector('.address-section');
            if (addressSection) {
              mapWidthPx = Math.max(300, Math.round(addressSection.clientWidth));
            } else {
              // 폴백: 컨테이너 부모나 화면 폭 기준
              const parent = container.parentElement;
              const fallbackWidth = parent ? parent.clientWidth : window.innerWidth;
              mapWidthPx = Math.max(300, Math.round(fallbackWidth - 40));
            }
            const mapHeightPx = Math.max(250, Math.min(400, Math.round(mapWidthPx * 0.4)));

            new window.daum.roughmap.Lander({
              "timestamp": "1758086878144",
              "key": "wg3bymc6rnu",
              "mapWidth": String(mapWidthPx),
              "mapHeight": String(mapHeightPx)
            }).render();
            console.log('다음 지도 초기화 성공 (반응형)', { mapWidthPx, mapHeightPx });
          } catch (error) {
            console.error('다음 지도 초기화 실패:', error);
          }
        } else if (activeSection === 'company') {
          console.log('다음 지도 스크립트 로딩 중...');
          // 스크립트가 아직 로드되지 않았다면 잠시 후 재시도 (debounce)
          if (retryTimer) clearTimeout(retryTimer);
          retryTimer = setTimeout(initDaumRoughMap, 300);
        }
      };

      // DOM이 준비되면 지도 초기화 (약간 빠르게)
      initTimer = setTimeout(initDaumRoughMap, 800);

      // 화면 리사이즈 시 지도 크기 업데이트 (debounce)
      const handleResize = () => {
        // 현재 섹션이 company일 때만 동작
        if (!document.getElementById('daumRoughmapContainer1758086878144')) return;
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          initDaumRoughMap();
        }, 250);
      };
      window.addEventListener('resize', handleResize);
      
      return () => {
        if (initTimer) clearTimeout(initTimer);
        if (retryTimer) clearTimeout(retryTimer);
        if (resizeTimer) clearTimeout(resizeTimer);
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [activeSection]); // activeSection이 변경될 때마다 지도 재초기화

  // 다음 우편번호 서비스 주소 검색 함수
  const openAddressSearch = (type, prefix) => {
    new window.daum.Postcode({
      oncomplete: function(data) {
        // 우편번호와 주소 정보를 해당 input에 설정
        const zipCodeElement = document.querySelector(`input[name="${prefix}ZipCode"]`);
        const addressElement = document.querySelector(`input[name="${prefix}Address"]`);
        
        if (zipCodeElement) zipCodeElement.value = data.zonecode;
        if (addressElement) addressElement.value = data.roadAddress || data.jibunAddress;
        
        // 상세주소 입력 필드에 포커스
        const detailElement = document.querySelector(`input[name="${prefix}Detail"]`);
        if (detailElement) detailElement.focus();
      }
    }).open();
  };

  const truckSpecs = [
    { type: '다마스', name: '다마스', width: 1.05, length: 1.60, height: 1.10, image: '/images/다마스.jpg' },
    { type: '라보', name: '라보', width: 1.35, length: 2.20, height: 0.00,image: '/images/라보.jpg' },
    { type: '1톤', name: '1톤', width: 1.60, length: 2.85, height: 0.00, image: '/images/1톤카고.jpg' },
    { type: '1톤 탑/윙', name: '1톤 탑/윙', width: 1.60, length: 2.85, height: 1.7, image: '/images/1톤탑윙.jpg' },
    { type: '1.4톤 카고', name: '1.4톤 카고', width: 1.68, length: 3.10, height: 0.00, image: '/images/1.4톤카고.jpg' },
    { type: '1.4톤 탑/윙', name: '1.4톤 탑/윙', width: 1.68, length: 3.10, height: 1.8, image: '/images/1.4톤탑윙.jpg' },
    { type: '2.5톤 카고', name: '2.5톤 카고', width: 1.80, length: 4.20, height: 0.00, image: '/images/2.5톤카고.jpg' },
    { type: '2.5톤 탑/윙', name: '2.5톤 탑/윙', width: 1.80, length: 4.20, height: 2.10, image: '/images/2.5톤탑윙.png' },
    { type: '3.5톤 카고', name: '3.5톤 카고', width: 2.00, length: 4.50, height: 0.00, image: '/images/3.5톤카고.jpg' },
    { type: '3.5톤 탑/윙', name: '3.5톤 탑/윙', width: 2.00, length: 4.50, height: 2.10, image: '/images/3.5톤탑윙.png' },
    { type: '5톤 카고', name: '5톤 카고', width: 2.28, length: 6.20, height: 0.00, image: '/images/5톤카고.jpg' },
    { type: '5톤 탑/윙', name: '5톤 탑/윙', width: 2.28, length: 6.20, height: 2.50, image: '/images/5톤윙바디.png' },
    { type: '5톤플카고', name: '5톤플', width: 2.35, length: 7.40, height: 2.50, image: '/images/5톤플축카고.jpg' },
    { type: '5톤축카고', name: '5톤축', width: 2.35, length: 7.40, height: 2.50, image: '/images/5톤플축카고.jpg' },
    { type: '5톤축 탑/윙', name: '5톤축 탑/윙', width: 2.35, length: 7.40, height: 2.50, image: '/images/5톤윙바디.png' },
    { type: '11톤 카고', name: '11톤', width: 2.35, length: 9.20, height: 2.70, image: '/images/11톤카고.jpg' },
    { type: '11톤 탑/윙', name: '11톤 탑/윙', width: 2.35, length: 9.70, height: 2.70, image: '/images/11톤윙바디.png' },
    { type: '18톤 카고', name: '18톤', width: 2.35, length: 10.00, height: 2.70, image: '/images/18톤카고.png' },
    { type: '18톤 탑/윙', name: '18톤 탑/윙', width: 2.40, length: 10.20, height: 2.70, image: '/images/18톤윙바디.png' },
    { type: '25톤 카고', name: '25톤', width: 2.35, length: 10.20, height: 2.70, image: '/images/25톤카고.png' },
    { type: '25톤 탑/윙', name: '25톤 탑/윙', width: 2.40, length: 10.20, height: 2.70, image: '/images/25톤윙.png' },
    { type: '추레라', name: '추레라', width: 2.40, length: 13.60, height: 2.70, image: '/images/추레라.jpg' }
  ];

  const handleServiceSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);
    
    // EmailJS 템플릿 파라미터 준비
    const templateParams = {
      to_email: 'buyoung2222@gmail.com',
      from_name: data.contactPerson || '고객',
      phone: data.phone || '',
      departure_zipcode: data.departureZipCode || '',
      departure_address: data.departureAddress || '',
      departure_detail: data.departureDetail || '',
      destination_zipcode: data.destinationZipCode || '',
      destination_address: data.destinationAddress || '',
      destination_detail: data.destinationDetail || '',
      cargo_type: data.cargoType || '',
      vehicle_size: data.vehicleSize || '',
      vehicle_type: data.vehicleType || '',
      preferred_date: data.preferredDate || '',
      detail_content: data.detailContent || '',
      request_type: activeSection === 'quote' ? '일반견적 요청' : '견적조회'
    };
    
    try {
      // EmailJS로 이메일 전송
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_GENERAL_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );
      
      alert('견적 요청이 성공적으로 전송되었습니다!');
      e.target.reset();
    } catch (error) {
      console.error('이메일 전송 실패:', error);
      alert('이메일 전송에 실패했습니다. 다시 시도해주세요.');
    }
  };

  const handleFloatingSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);
    
    // EmailJS 템플릿 파라미터 준비
    const templateParams = {
      to_email: 'buyoung2222@gmail.com',
      from_name: data.name || '고객',
      from_email: data.email || '',
      phone: data.phone || '',
      inquiry_content: data.inquiry || '',
      request_type: '상담 신청'
    };
    
    try {
      // EmailJS로 이메일 전송
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_CONSULTATION_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );
      
      alert('상담 신청이 성공적으로 전송되었습니다!');
      setShowFloatingForm(false);
      e.target.reset();
    } catch (error) {
      console.error('이메일 전송 실패:', error);
      alert('이메일 전송에 실패했습니다. 다시 시도해주세요.');
    }
  };



  return (
    <div className="App">
      {/* Navigation Bar */}
      <nav className="navbar">
        <div className="container">
          <div className="nav-brand">
            <a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('home'); }} className="logo-link">
              <img src="/images/Layer1.png" alt="부영특송 로고" className="logo-image" />
            </a>
          </div>
          <button 
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <ul className={`nav-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>

            <li><button onClick={() => { setActiveSection('home'); setIsMobileMenuOpen(false); }} className={activeSection === 'home' ? 'active' : ''}>홈</button></li>
            <li className="dropdown">
              <button>회사 소개 ▼</button>
              <ul className="dropdown-menu">
                <li><button onClick={() => { setActiveSection('greeting'); setIsMobileMenuOpen(false); }}>인사말씀</button></li>
                <li><button onClick={() => { setActiveSection('company'); setIsMobileMenuOpen(false); }}>오시는 길</button></li>
                <li><button onClick={() => { setActiveSection('vehicles'); setIsMobileMenuOpen(false); }}>화물차 제원</button></li>
              </ul>
            </li>
            <li className="dropdown">
              <button>견적/화물운송요금표 ▼</button>
              <ul className="dropdown-menu">
                <li><button onClick={() => { setActiveSection('quote'); setIsMobileMenuOpen(false); }}>일반견적 요청</button></li>
                <li><button onClick={() => { setActiveSection('compareQuote'); setIsMobileMenuOpen(false); }}>화물운송요금표</button></li>
              </ul>
            </li>

          </ul>
          <div className="nav-contact">
            <span>📞 02)2614-2222</span>
          </div>
        </div>
      </nav>
      
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="mobile-menu-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
      )}

      {/* Main Content */}
      {activeSection === 'home' && (
        <>
          {/* Hero Section */}
          <section className="hero" style={{
            background: 'linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), url("/images/transportation.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}>
            <div className="container">
              <div className="hero-content">
                <div className="hero-left">
                  <div className="hero-badge">전국24시 화물운송</div>
                  <h1 style={{wordBreak: 'keep-all', wordWrap: 'break-word'}}>
                    신속 정확한 개별화물 운송<br/>
                    <span className="highlight-number">02)2614-2222</span>
                  </h1>
                  <p className="hero-subtitle" style={{wordBreak: 'keep-all', wordWrap: 'break-word'}}>일반화물부터 장재물까지 전문으로 취급하는 화물운송 전문업체</p>
                  <div className="price-info">
                    <div className="price-item">🚛 1톤 (50,000원 부터)</div>
                    <div className="price-item">🚚 2.5톤 (90,000원 부터)</div>
                    <div className="price-item">🚛 5톤 (130,000원 부터)</div>
                  </div>
                  <div className="hero-buttons">
                    <a href="https://order.02-2614-2222.com" className="hero-cta-button" style={{textDecoration: 'none', marginRight: '10px', flex: '1', maxWidth: '250px', textAlign: 'center'}}>
                      <span style={{display: 'inline-block'}}>퀵/일반화물 접수</span>
                    </a>
                    <button 
                      onClick={() => {
                        setActiveSection('quote');
                        setTimeout(() => {
                          const quoteSection = document.getElementById('quote-section');
                          if (quoteSection) {
                            quoteSection.scrollIntoView({ behavior: 'smooth' });
                          }
                        }, 100);
                      }} 
                      className="hero-cta-button" 
                      style={{textDecoration: 'none', backgroundColor: '#28a745', flex: '1', maxWidth: '250px', textAlign: 'center'}}
                    >
                      <span style={{display: 'inline-block'}}>화물견적 요청</span>
                    </button>
                  </div>
                </div>
                <div className="hero-right" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                  <div style={{textAlign: 'center', marginBottom: '20px'}}>
                    <h2 style={{fontSize: '2.2rem', fontWeight: 'bold', color: '#333', marginBottom: '10px'}}>합리적인 화물 주선 서비스</h2>
                    <p style={{fontSize: '1.4rem', color: '#666', marginBottom: '0', wordBreak: 'keep-all', wordWrap: 'break-word'}}>편리하게 화물 배차를 접수하세요</p>
                  </div>
                  <div className="hero-visual">
                    <div className="home-image">
                      <img src="/images/홈로고수정3.png" alt="홈로고수정3" loading="lazy" style={{width: '280px', height: '420px', objectFit: 'contain'}}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* 주요 서비스 */}
          <section className="services">
            <div className="container">
              <h3>주요 서비스</h3>
              <p className="services-subtitle">부영특송만의 차별화된 서비스</p>
              <div className="service-grid">
                <div className="service-card">
                  <div className="service-image">
                    <img src="/images/truck-highway.jpg" alt="개인화물서비스" loading="lazy" />
                  </div>
                  <div className="service-content">
                    <h4>개인화물 <span className="service-tag green">(일반고객전문)</span></h4>
                    <p>개인 고객을 위한 맞춤형 화물 운송 서비스로 안전하고 신속한 배송을 보장합니다.</p>
                    <div className="service-vehicles">
                      차량정보: 다마스, 라보, 포터, 봉고
                    </div>
                  </div>
                </div>
                <div className="service-card">
                  <div className="service-image">
                    <img src="/images/기업화물.jpg" alt="전국화물서비스" loading="lazy" />
                  </div>
                  <div className="service-content">
                    <h4>전국화물 <span className="service-tag blue">(기업고객전문)</span></h4>
                    <p>전국 어디든 안전하고 빠른 화물 운송 서비스를 제공합니다.</p>
                    <div className="service-vehicles">
                      차량정보: 일반카고, 윙탑, 호로탑, 냉탑, 리프트카
                    </div>
                  </div>
                </div>
                <div className="service-card">
                  <div className="service-image">
                    <img src="/images/혼적.jpg" alt="혼적화물서비스" loading="lazy" />
                  </div>
                  <div className="service-content">
                    <h4>혼적화물 <span className="service-tag orange">(배송비절감)</span></h4>
                    <p>같은 방향으로 가는 차량에 같이 실어 경제적인 운송 서비스를 제공합니다.</p>
                    <div className="service-vehicles">
                      차량정보: 카고, 탑차, 윙카, 리프트, 무진동
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* 통계 섹션 */}
          <section className="stats-section">
            <div className="container">
              <div className="stats-grid">
                <div className="stat-item">
                  <div className="stat-number">3,000,000+</div>
                  <div className="stat-label">누적 운송건수</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">1500+</div>
                  <div className="stat-label">협력 기사단</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">24</div>
                  <div className="stat-label">시간 운영</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">99.8%</div>
                  <div className="stat-label">고객 만족도</div>
                </div>
              </div>
            </div>
          </section>

          {/* 회사 소개 */}
          <section className="company-intro">
            <div className="container">
              <div className="intro-content">
                <div className="intro-text">
                  <h2 className="intro-title">부영특송에 오신 것을 환영합니다</h2>
                  <p>
                    저희 부영특송은 고객의 소중한 화물을 안전하고 신속하게 운송하는 것을 최우선으로 하는 전문 화물운송업체입니다.
                  </p>
                  <p className="company-description">
                    오랜 경험과 노하우를 바탕으로 최고의 서비스를 제공합니다.
                  </p>
                  <div className="intro-features">
                    <div className="feature">
                      <h4>안전운송</h4>
                      <p>전문 기사진과 체계적인 안전관리</p>
                    </div>
                    <div className="feature">
                      <h4>신속배송</h4>
                      <p>최적화된 배송 루트로 빠른 운송</p>
                    </div>
                    <div className="feature">
                      <h4>합리적 가격</h4>
                      <p>경쟁력 있는 운송비와 투명한 요금</p>
                    </div>
                  </div>
                </div>
                <div className="intro-image">
                  <div className="image-placeholder">
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* 서비스 안내 */}
          <section className="services-section">
            <div className="container">
              <h2>서비스 안내</h2>
              <p className="section-subtitle">부영특송만의 차별화된 서비스</p>
              <div className="services-grid">
                <div className="service-card">
                  <div className="service-icon">
                    <img src="/images/퀵.png" alt="퀵서비스" style={{width: '80px', height: '80px'}} loading="lazy" />
                  </div>
                  <h3>퀵 서비스/소규모 짐 운송</h3>
                  <p>긴급배송과 소량화물 운송에 최적화된 빠르고 경제적인 서비스</p>
                  <div className="service-price">다마스 25,000원부터</div>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="/images/대형화물운송.png" alt="기업물류 운송" style={{width: '80px', height: '80px'}} loading="lazy" />
                  </div>
                  <h3>기업물류 운송</h3>
                  <p>기업 전용 물류 솔루션으로 정기적이고 안정적인 운송 서비스 제공</p>
                  <div className="service-price">맞춤 견적 상담</div>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="/images/사무용짐 이동.png" alt="혼적화물 서비스" style={{width: '80px', height: '80px'}} loading="lazy" />
                  </div>
                  <h3>혼적화물(합짐) 서비스</h3>
                  <p>같은 방향으로 가는 차량에 같이 싵고 보다 저렴하게 운송하는 서비스</p>
                  <div className="service-price">카고 / 탑차 / 윙카 / 리프트 / 무진동</div>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="/images/24시.png" alt="24시운송" style={{width: '80px', height: '80px'}} loading="lazy" />
                  </div>
                  <h3>24시운송</h3>
                  <p>24시간 전국어디든 이용 가능한 긴급 운송 서비스</p>
                  <div className="service-price">24시간 대기</div>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="/images/전문 컨설팅.png" alt="전문가 컨설팅" style={{width: '80px', height: '80px'}} loading="lazy" />
                  </div>
                  <h3>전문가 컨설팅</h3>
                  <p>물류 전문가의 맞춤형 상담으로 최적의 운송 솔루션 제공</p>
                  <div className="service-price">무료 상담</div>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="/images/일반물류.png" alt="전국화물서비스" style={{width: '80px', height: '80px'}} loading="lazy" />
                  </div>
                  <h3>전국화물서비스</h3>
                  <p>일반카고 / 윙탑 / 호로탑 / 냉탑 / 리프트카 등 다양한 차량 보유</p>
                  <div className="service-price">배차시스템 최적화</div>
                </div>
              </div>
              <div className="more-info">
                <button onClick={() => setActiveSection('vehicles')} className="link-button">
                  내게 맞는 화물차 보러가기 →
                </button>
              </div>
            </div>
          </section>

          {/* 실시간 견적 화물접수 */}
          <section className="estimate-section">
            <div className="container">
              <div className="estimate-header">
                <h2>일반견적 요청</h2>

              </div>
              <div className="estimate-form">
                <form onSubmit={handleServiceSubmit}>
                  <div className="form-section">
                    <h3>출발지</h3>
                    <div className="address-search-section">
                      <div className="address-input-group">
                        <input 
                          type="text" 
                          name="departureZipCode" 
                          placeholder="우편번호" 
                          readOnly
                          style={{width: '120px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', marginRight: '10px', backgroundColor: '#f9f9f9'}}
                        />
                        <button 
                          type="button" 
                          onClick={() => openAddressSearch('departure', 'departure')}
                          style={{padding: '10px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer'}}
                        >
                          주소 검색
                        </button>
                      </div>
                      <input 
                        type="text" 
                        name="departureAddress" 
                        placeholder="주소를 검색해주세요" 
                        readOnly
                        required
                        style={{margin: '10px 0 5px 0', width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', display: 'block', backgroundColor: '#f9f9f9'}}
                      />
                      <input 
                        type="text" 
                        name="departureDetail" 
                        placeholder="상세주소를 입력하세요 (예: 123번지, 456호)" 
                        style={{margin: '5px 0', width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', display: 'block'}}
                      />
                    </div>
                  </div>
                  <div className="form-section">
                    <h3>도착지</h3>
                    <div className="address-search-section">
                      <div className="address-input-group">
                        <input 
                          type="text" 
                          name="destinationZipCode" 
                          placeholder="우편번호" 
                          readOnly
                          style={{width: '120px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', marginRight: '10px', backgroundColor: '#f9f9f9'}}
                        />
                        <button 
                          type="button" 
                          onClick={() => openAddressSearch('destination', 'destination')}
                          style={{padding: '10px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer'}}
                        >
                          주소 검색
                        </button>
                      </div>
                      <input 
                        type="text" 
                        name="destinationAddress" 
                        placeholder="주소를 검색해주세요" 
                        readOnly
                        required
                        style={{margin: '10px 0 5px 0', width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', display: 'block', backgroundColor: '#f9f9f9'}}
                      />
                      <input 
                        type="text" 
                        name="destinationDetail" 
                        placeholder="상세주소를 입력하세요 (예: 123번지, 456호)" 
                        style={{margin: '5px 0', width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', display: 'block'}}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>운송물건</label>
                      <select name="cargoType" required>
                        <option value="">선택하세요</option>
                        <option value="일반화물">일반화물</option>
                        <option value="가전제품">가전제품</option>
                        <option value="가구">가구</option>
                        <option value="전자제품">전자제품</option>
                        <option value="사무용품">사무용품</option>
                        <option value="건축자재">건축자재</option>
                        <option value="기계류">기계류</option>
                        <option value="식료품">식료품</option>
                        <option value="의류">의류</option>
                        <option value="기타">기타</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>화물차량</label>
                      <select 
                        name="vehicleSize" 
                        required

                      >
                        <option value="">선택하세요</option>
                        <option value="상담필요">상담필요</option>
                        <option value="오토바이">오토바이</option>
                        <option value="라보(0.5톤)">라보(0.5톤)</option>
                        <option value="다마스(0.5톤)">다마스(0.5톤)</option>
                        <option value="1톤">1톤</option>
                        <option value="1.4톤">1.4톤</option>
                        <option value="2.5톤">2.5톤</option>
                        <option value="3.5톤">3.5톤</option>
                        <option value="5톤">5톤</option>
                        <option value="5톤플">5톤플</option>
                        <option value="5톤축">5톤축</option>
                        <option value="8톤">8톤</option>
                        <option value="11톤">11톤</option>
                        <option value="18톤">18톤</option>
                        <option value="25톤">25톤</option>
                        <option value="추레라">추레라</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label>차종</label>
                      <select name="vehicleType" required>
                        <option value="">선택하세요</option>
                        <option value="상담필요">상담필요</option>
                        <option value="일반차량">일반차량</option>
                        <option value="냉동차">냉동차</option>
                        <option value="냉장차">냉장차</option>
                        <option value="윙바디">윙바디</option>
                        <option value="탑차">탑차</option>
                        <option value="카고">카고</option>
                        <option value="특수차량">특수차량</option>
                        <option value="컨테이너">컨테이너</option>
                        <option value="덤프트럭">덤프트럭</option>
                        <option value="크레인">크레인</option>
                        <option value="기타">기타</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>이름/담당자</label>
                      <input type="text" name="contactPerson" placeholder="이름 또는 담당자명을 입력하세요" required />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>연락처</label>
                      <input type="tel" name="phone" placeholder="연락처를 입력하세요" required />
                    </div>
                    <div className="form-group">
                      <label>희망 운송일</label>
                      <input type="date" name="transportDate" required />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>결제 방법</label>
                      <select name="paymentMethod" required>
                        <option value="">선택하세요</option>
                        <option value="착불">착불</option>
                        <option value="신용">신용</option>
                        <option value="현금">현금</option>
                        <option value="계좌이체">계좌이체</option>
                        <option value="카드결제">카드결제</option>
                        <option value="월 결제">월 결제</option>
                        <option value="격주 결제">격주 결제</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>상세 내용</label>
                    <textarea name="details" placeholder="화물 상세 정보, 특이사항 등을 입력하세요" rows="4"></textarea>
                  </div>
                  
                  <div className="warning-box">
                    차량 배차관련 상담이 필요하신 경우 차종 탭에서 상담필요를 선택해주십쇼.
                  </div>
                  
                  <div className="fare-info-box">
                    <h4>📋 운임표 안내</h4>
                    <p>• 운임은 거리와 차종을 기준으로 산정됩니다.</p>
                    <p>• 실제 운임은 화물의 종류, 적재 조건, 운송 시기 등에 따라 달라질 수 있습니다.</p>
                    <p>• 정확한 견적은 상담을 통해 확인해 드립니다.</p>
                  </div>
                  
                  <button type="submit" className="submit-btn">견적 요청하기</button>
                </form>
              </div>
            </div>
          </section>


        </>
      )}

      {/* 인사말 */}
      {activeSection === 'greeting' && (
        <section className="content-section">
          <div className="container">
            <h2>인사말씀</h2>
            <div className="greeting-content">
              <h3>안녕하십니까. 부영특송 대표 이영섭입니다.</h3>
              <p>화물주선업에 발을 들인 지 벌써 40여 년이 흘렀습니다. 1980년대 초, 젊은 나이에 이 업계에 뛰어들어 현장에서 몸소 배우고 익힌 경험들이 오늘의 저를 만들었습니다. 그리고 2005년 7월 4일, 그동안 쌓아온 모든 노하우를 집약하여 부영특송을 설립했습니다.</p>
              <p>21년간 부영특송을 이끌어오면서, 그리고 40여 년간 이 업계에서 쌓아온 경험을 통해 한 가지 확신하게 된 것이 있습니다. 화물운송주선업은 단순히 물건을 옮기는 일이 아니라는 것입니다. 고객의 소중한 물품 하나하나에 담긴 간절함을 이해하고, 그것을 안전하게 목적지까지 전달하는 것이야말로 우리가 해야 할 진정한 일이라고 생각합니다.</p>
              <p>40여 년의 현장 경험과 21년간의 사업 운영을 통해 쌓아온 신뢰와 노하우는 부영특송만의 가장 큰 자산입니다. 시대가 변하고 물류 환경이 급변해도, 변하지 않는 것은 고객을 향한 진심과 책임감입니다.</p>
              <div className="signature">
                <p><strong>부영특송 대표이사 이영섭</strong></p>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* 오시는 길 */}
      {activeSection === 'company' && (
        <section className="content-section">
          <div className="container">
            <div className="directions-section">
              <h2>🗺️ 오시는 길</h2>
              
              <div className="address-section">
                <h3>📍 주소</h3>
                <p><strong>서울 구로구 경인로43길 56, 다동 309호</strong></p>
                <p>📞 지역번호: 02-2614-2222</p>
                <p>📱 휴대폰: 010-4261-2221</p>
              </div>

              <div className="map-section">
                <h3>🗺️ 지도</h3>
                <div id="daumRoughmapContainer1758086878144" className="root_daum_roughmap root_daum_roughmap_landing"></div>

              </div>
            </div>
          </div>
        </section>
      )}

      {/* 화물차 제원 */}
      {activeSection === 'vehicles' && (
        <section className="content-section">
          <div className="container">
            <h2>화물차 제원</h2>
            
            {/* 화물차량 규격표 */}
            <div className="truck-specs-section">
              <h3>화물차량 규격표</h3>
              <div className="specs-grid">
                {truckSpecs.map((truck, index) => (
                  <div key={index} className="spec-card">
                    {truck.image && (
                      <div className="truck-image">
                        <img src={truck.image} alt={truck.name} className="truck-photo" />
                      </div>
                    )}
                    <div className="truck-header">
                      <div className="truck-type">{truck.type}</div>
                    </div>
                    <div className="dimensions">
                      <div>넓이 {truck.width.toFixed(2)}m</div>
                      <div>길이 {truck.length.toFixed(2)}m</div>
                      <div>높이 {truck.height.toFixed(2)}m</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="notice">
                <p>※ 위 규격은 일반적인 기준이며, 실제 차량과 다소 차이가 있을 수 있습니다.</p>
                <p>※ 고속도로 높이제한: 4m 20cm, 일반도로: 4m 10cm</p>
              </div>
            </div>
            <div className="vehicle-types">
              <div className="vehicle-grid">
              </div>
            </div>
          </div>
        </section>
      )}

      {/* 견적조회 */}
      {activeSection === 'quote' && (
        <section className="content-section" id="quote-section">
          <div className="container">
            <h2>견적조회</h2>
            <div className="quote-form">
              <form onSubmit={handleServiceSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>출발지</label>
                    <div style={{display: 'flex', gap: '10px', marginBottom: '10px'}}>
                      <input 
                        type="text" 
                        name="departureZipCode" 
                        placeholder="우편번호" 
                        readOnly 
                        style={{width: '120px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px'}} 
                      />
                      <button 
                        type="button" 
                        onClick={() => openAddressSearch('departure', 'departure')} 
                        style={{padding: '10px 16px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer'}}
                      >
                        주소검색
                      </button>
                    </div>
                    <input 
                      type="text" 
                      name="departureAddress" 
                      placeholder="도로명 주소" 
                      readOnly 
                      style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', marginBottom: '10px'}} 
                    />
                    <input 
                      type="text" 
                      name="departureDetail" 
                      placeholder="상세주소를 입력하세요 (예: 123번지, 456호)" 
                      style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px'}} 
                    />
                  </div>
                  <div className="form-group">
                    <label>도착지</label>
                    <div style={{display: 'flex', gap: '10px', marginBottom: '10px'}}>
                      <input 
                        type="text" 
                        name="destinationZipCode" 
                        placeholder="우편번호" 
                        readOnly 
                        style={{width: '120px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px'}} 
                      />
                      <button 
                        type="button" 
                        onClick={() => openAddressSearch('destination', 'destination')} 
                        style={{padding: '10px 16px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer'}}
                      >
                        주소검색
                      </button>
                    </div>
                    <input 
                      type="text" 
                      name="destinationAddress" 
                      placeholder="도로명 주소" 
                      readOnly 
                      style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', marginBottom: '10px'}} 
                    />
                    <input 
                      type="text" 
                      name="destinationDetail" 
                      placeholder="상세주소를 입력하세요 (예: 123번지, 456호)" 
                      style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px'}} 
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>운송물건</label>
                    <select name="cargoType" required>
                      <option value="">선택하세요</option>
                      <option value="일반화물">일반화물</option>
                      <option value="가전제품">가전제품</option>
                      <option value="가구">가구</option>
                      <option value="전자제품">전자제품</option>
                      <option value="사무용품">사무용품</option>
                      <option value="건축자재">건축자재</option>
                      <option value="기계류">기계류</option>
                      <option value="식료품">식료품</option>
                      <option value="의류">의류</option>
                      <option value="기타">기타</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>화물차량</label>
                    <select name="vehicleSize" required>
                      <option value="">선택하세요</option>
                      <option value="상담필요">상담필요</option>
                      <option value="오토바이">오토바이</option>
                      <option value="라보(0.5톤)">라보(0.5톤)</option>
                      <option value="다마스(0.5톤)">다마스(0.5톤)</option>
                      <option value="1톤">1톤</option>
                      <option value="1.4톤">1.4톤</option>
                      <option value="2.5톤">2.5톤</option>
                      <option value="3.5톤">3.5톤</option>
                      <option value="5톤">5톤</option>
                      <option value="5톤플">5톤플</option>
                      <option value="5톤축">5톤축</option>
                      <option value="8톤">8톤</option>
                      <option value="11톤">11톤</option>
                      <option value="18톤">18톤</option>
                      <option value="25톤">25톤</option>
                      <option value="추레라">추레라</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>차종</label>
                    <select name="vehicleType" required>
                      <option value="">선택하세요</option>
                      <option value="상담필요">상담필요</option>
                      <option value="일반차량">일반차량</option>
                      <option value="냉동차">냉동차</option>
                      <option value="냉장차">냉장차</option>
                      <option value="윙바디">윙바디</option>
                      <option value="탑차">탑차</option>
                      <option value="카고">카고</option>
                      <option value="특수차량">특수차량</option>
                      <option value="컨테이너">컨테이너</option>
                      <option value="덤프트럭">덤프트럭</option>
                      <option value="크레인">크레인</option>
                      <option value="기타">기타</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>이름/담당자</label>
                    <input type="text" name="contactPerson" placeholder="이름 또는 담당자명을 입력하세요" required />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>연락처</label>
                    <input type="tel" name="phone" placeholder="연락처를 입력하세요" required />
                  </div>
                  <div className="form-group">
                    <label>희망 운송일</label>
                    <input type="date" name="transportDate" required />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>결제 방법</label>
                    <select name="paymentMethod" required>
                      <option value="">선택하세요</option>
                      <option value="착불">착불</option>
                      <option value="신용">신용</option>
                      <option value="현금">현금</option>
                      <option value="계좌이체">계좌이체</option>
                      <option value="카드결제">카드결제</option>
                      <option value="월 결제">월 결제</option>
                      <option value="격주 결제">격주 결제</option>
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>상세 내용</label>
                  <textarea name="details" rows="4" placeholder="화물 상세 정보, 특이사항 등을 입력하세요"></textarea>
                </div>
                
                <div className="warning-box">
                  차량 배차관련 상담이 필요하신 경우 차종 탭에서 상담필요를 선택해주십쇼.
                </div>
                
                <button type="submit" className="submit-btn">견적 요청하기</button>
              </form>
            </div>
          </div>
        </section>
      )}



      {/* 화물운송요금표 */}
      {activeSection === 'compareQuote' && (
        <section className="content-section">
          <div className="container">
            <h2>화물운송요금표</h2>
            <div className="freight-rate-content">
              <div className="rate-intro">
                <h3>거리·차종별 화물운송 요금표</h3>
                <p>거리별 표준요금을 확인하세요. (단위: 만원/VAT별도)</p>
              </div>
              
              <div className="rate-table-section">
                <div className="table-responsive">
                  <table className="freight-rate-table">
                    <thead>
                      <tr>
                        <th>거리/차종</th>
                        <th>1톤</th>
                        <th>1.4톤</th>
                        <th>2.5톤</th>
                        <th>3.5톤</th>
                        <th>5톤장</th>
                        <th>5톤플</th>
                        <th>5톤축</th>
                        <th>11톤</th>
                        <th>18톤</th>
                        <th>25톤</th>
                        <th>추레라</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="distance-cell">20km</td>
                        <td>4</td>
                        <td>5</td>
                        <td>7</td>
                        <td>8</td>
                        <td>9</td>
                        <td>11</td>
                        <td>12</td>
                        <td>13</td>
                        <td>18</td>
                        <td>20</td>
                        <td>22</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">30km</td>
                        <td>5</td>
                        <td>6</td>
                        <td>8</td>
                        <td>9</td>
                        <td>10</td>
                        <td>12</td>
                        <td>13</td>
                        <td>14</td>
                        <td>19</td>
                        <td>21</td>
                        <td>23</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">50km</td>
                        <td>6</td>
                        <td>7</td>
                        <td>9</td>
                        <td>10</td>
                        <td>12</td>
                        <td>13</td>
                        <td>14</td>
                        <td>15</td>
                        <td>20</td>
                        <td>22</td>
                        <td>24</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">70km</td>
                        <td>7</td>
                        <td>8</td>
                        <td>10</td>
                        <td>11</td>
                        <td>13</td>
                        <td>14</td>
                        <td>16</td>
                        <td>17</td>
                        <td>21</td>
                        <td>23</td>
                        <td>25</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">90km</td>
                        <td>8</td>
                        <td>9</td>
                        <td>11</td>
                        <td>12</td>
                        <td>14</td>
                        <td>16</td>
                        <td>18</td>
                        <td>19</td>
                        <td>22</td>
                        <td>25</td>
                        <td>27</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">110km</td>
                        <td>9</td>
                        <td>10</td>
                        <td>12</td>
                        <td>13</td>
                        <td>15</td>
                        <td>17</td>
                        <td>19</td>
                        <td>20</td>
                        <td>24</td>
                        <td>27</td>
                        <td>29</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">130km</td>
                        <td>10</td>
                        <td>11</td>
                        <td>13</td>
                        <td>14</td>
                        <td>16</td>
                        <td>18</td>
                        <td>20</td>
                        <td>21</td>
                        <td>25</td>
                        <td>28</td>
                        <td>30</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">150km</td>
                        <td>11</td>
                        <td>12</td>
                        <td>14</td>
                        <td>15</td>
                        <td>17</td>
                        <td>19</td>
                        <td>21</td>
                        <td>23</td>
                        <td>27</td>
                        <td>30</td>
                        <td>33</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">170km</td>
                        <td>12</td>
                        <td>13</td>
                        <td>15</td>
                        <td>16</td>
                        <td>18</td>
                        <td>20</td>
                        <td>22</td>
                        <td>24</td>
                        <td>28</td>
                        <td>31</td>
                        <td>35</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">200km</td>
                        <td>13</td>
                        <td>14</td>
                        <td>18</td>
                        <td>19</td>
                        <td>21</td>
                        <td>23</td>
                        <td>25</td>
                        <td>27</td>
                        <td>30</td>
                        <td>32</td>
                        <td>36</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">250km</td>
                        <td>15</td>
                        <td>16</td>
                        <td>19</td>
                        <td>20</td>
                        <td>23</td>
                        <td>25</td>
                        <td>27</td>
                        <td>33</td>
                        <td>39</td>
                        <td>42</td>
                        <td>45</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">300km</td>
                        <td>17</td>
                        <td>18</td>
                        <td>25</td>
                        <td>26</td>
                        <td>28</td>
                        <td>30</td>
                        <td>33</td>
                        <td>37</td>
                        <td>45</td>
                        <td>48</td>
                        <td>50</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">350km</td>
                        <td>19</td>
                        <td>20</td>
                        <td>27</td>
                        <td>28</td>
                        <td>30</td>
                        <td>33</td>
                        <td>36</td>
                        <td>38</td>
                        <td>50</td>
                        <td>53</td>
                        <td>56</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">400km</td>
                        <td>20</td>
                        <td>21</td>
                        <td>28</td>
                        <td>30</td>
                        <td>32</td>
                        <td>35</td>
                        <td>38</td>
                        <td>42</td>
                        <td>55</td>
                        <td>58</td>
                        <td>65</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">450km</td>
                        <td>22</td>
                        <td>23</td>
                        <td>30</td>
                        <td>32</td>
                        <td>34</td>
                        <td>37</td>
                        <td>40</td>
                        <td>44</td>
                        <td>58</td>
                        <td>62</td>
                        <td>69</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">500km</td>
                        <td>25</td>
                        <td>26</td>
                        <td>32</td>
                        <td>34</td>
                        <td>36</td>
                        <td>38</td>
                        <td>42</td>
                        <td>46</td>
                        <td>60</td>
                        <td>64</td>
                        <td>71</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">550km</td>
                        <td>27</td>
                        <td>28</td>
                        <td>35</td>
                        <td>37</td>
                        <td>39</td>
                        <td>41</td>
                        <td>45</td>
                        <td>48</td>
                        <td>63</td>
                        <td>67</td>
                        <td>75</td>
                      </tr>
                      <tr>
                        <td className="distance-cell">600km</td>
                        <td>30</td>
                        <td>31</td>
                        <td>38</td>
                        <td>40</td>
                        <td>42</td>
                        <td>43</td>
                        <td>47</td>
                        <td>50</td>
                        <td>65</td>
                        <td>70</td>
                        <td>79</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              
              <div className="rate-notice">
                <h4>📋 요금표 안내사항</h4>
                <ul>
                  <li>위 요금은 기본 운송료이며, 실제 요금은 화물의 종류, 적재조건, 운송시간 등에 따라 달라질 수 있습니다.</li>
                  <li>야간할증(22:00~06:00): 기본요금의 20% 추가</li>
                  <li>주말/공휴일 할증: 기본요금의 10% 추가</li>
                  <li>대기료: 30분 초과 시 시간당 1만원</li>
                  <li>상하차비: 별도 협의 (층수, 엘리베이터 유무에 따라 차등)</li>
                </ul>
              </div>
              
              <div className="quote-request-section">
                <h4>정확한 견적을 원하시나요?</h4>
                <p>상세한 운송 조건을 입력하시면 정확한 견적을 제공해드립니다.</p>
                <div className="quote-buttons">
                  <button 
                    onClick={() => setActiveSection('quote')} 
                    className="quote-btn primary"
                  >
                    견적 요청하기
                  </button>

                </div>
              </div>
              
              <div className="contact-info">
                <div className="contact-card">
                  <h5>📞 전화 상담</h5>
                  <p className="phone-number">02)2614-2222</p>
                  <p>24시간 상담 가능</p>
                </div>
                <div className="contact-card">
                  <h5>💬 카카오톡 상담</h5>
                  <p>@(주)부영특송</p>
                  <p>실시간 채팅 상담</p>
                </div>
                <div className="contact-card">
                  <h5>📧 이메일 문의</h5>
                  <p>buyoung2222@gmail.com</p>
                  <p>24시간 내 답변</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}







      {/* 플로팅 상담 버튼들 */}
      <div className="floating-contact">
        <div className="floating-buttons">
          <div 
            className="phone-btn-wrapper"
            data-size="large" 
            data-support-multiple-densities="true"
            onClick={() => window.open('tel:02-2614-2222')}
            title="전화 상담"
          >
            <span className="btn-icon">📞</span>
            <span className="btn-text">전화상담</span>
          </div>
          <div 
            id="kakao-talk-channel-add-button"
            title="카카오톡 채널 추가"
          >
          </div>
        </div>
      </div>

      {/* 정책 팝업 모달 - 개인정보취급방침 */}
      {isPrivacyOpen && (
        <div
          className="policy-modal-overlay"
          onClick={() => setIsPrivacyOpen(false)}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000
          }}
        >
          <div
            className="policy-modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: '12px', width: '90%', maxWidth: '720px',
              maxHeight: '80vh', overflowY: 'auto', boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
              padding: '24px'
            }}
          >
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px'}}>
              <h3 style={{margin: 0}}>개인정보취급방침</h3>
              <button onClick={() => setIsPrivacyOpen(false)} style={{border: 'none', background: 'transparent', fontSize: '20px', cursor: 'pointer'}}>✕</button>
            </div>
            <div style={{fontSize: '14px', color: '#333', lineHeight: 1.6}}>
              <p>&lt;부영특송&gt;('www.02-2614-2222.com'이하 '부영특송')은(는) 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.</p>
              <p>&lt;부영특송&gt;('부영특송')은(는) 회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.</p>
              <p>○ 본 방침은 2025년 11월 1일부터 시행됩니다.</p>

              <h4>1. 개인정보의 처리 목적</h4>
              <p>&lt;부영특송&gt;('www.02-2614-2222.com'이하 '부영특송')은(는) 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적 이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다.</p>
              <ul>
                <li>가. 견적문의 등을 목적으로 개인정보를 처리합니다.</li>
              </ul>

              <h4>2. 개인정보 파일 현황</h4>
              <p>1. 개인정보 파일명: 부영특송 개인정보</p>
              <ul>
                <li>개인정보 항목: 이메일, 휴대전화번호, 이름, 주소, 회사전화번호, 부서, 회사명, 서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보</li>
                <li>수집방법: 홈페이지</li>
                <li>보유근거: 개인정보보호법</li>
                <li>보유기간: 3년</li>
                <li>관련법령: 소비자의 불만 또는 분쟁처리에 관한 기록 3년</li>
              </ul>

              <h4>3. 개인정보의 처리 및 보유 기간</h4>
              <p>① &lt;부영특송&gt;('부영특송')은(는) 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>
              <p>② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
              <p>1. 견적문의: 견적문의와 관련한 개인정보는 수집·이용에 관한 동의일로부터 3년까지 위 이용목적을 위하여 보유·이용됩니다.</p>
              <ul>
                <li>보유근거: 개인정보보호법</li>
                <li>관련법령: 소비자의 불만 또는 분쟁처리에 관한 기록 3년</li>
                <li>예외사유: 해당 없음</li>
              </ul>

              <h4>4. 개인정보의 제3자 제공에 관한 사항</h4>
              <p>① &lt;부영특송&gt;('www.02-2614-2222.com'이하 '부영특송')은(는) 정보주체의 동의, 법률의 특별한 규정 등 개인정보보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</p>
              <p>② &lt;부영특송&gt;('www.02-2614-2222.com')은(는) 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.</p>
              <p>1. &lt;부영특송&gt;</p>
              <ul>
                <li>개인정보를 제공받는 자: 부영특송</li>
                <li>제공받는 자의 개인정보 이용목적: 이메일, 휴대전화번호, 이름, 주소, 회사전화번호, 부서, 회사명, 서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보</li>
                <li>제공받는 자의 보유·이용기간: 3년</li>
              </ul>

              <h4>5. 개인정보처리 위탁</h4>
              <p>① &lt;부영특송&gt;('부영특송')은(는) 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
              <ul>
                <li>위탁받는 자(수탁자): -</li>
                <li>위탁하는 업무의 내용: -</li>
                <li>위탁기간: -</li>
              </ul>
              <p>② &lt;부영특송&gt;('www.02-2614-2222.com'이하 '부영특송')은(는) 위탁계약 체결 시 개인정보보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>
              <p>③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</p>

              <h4>6. 정보주체와 법정대리인의 권리·의무 및 그 행사방법</h4>
              <p>이용자는 개인정보주체로써 다음과 같은 권리를 행사할 수 있습니다.</p>
              <p>① 정보주체는 부영특송에 대해 언제든지 개인정보 열람, 정정, 삭제, 처리정지 요구 등의 권리를 행사할 수 있습니다.</p>
              <p>② 제1항에 따른 권리 행사는 부영특송에 대해 개인정보보호법 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 부영특송은(는) 이에 대해 지체 없이 조치하겠습니다.</p>
              <p>③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</p>
              <p>④ 개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조 제5항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다.</p>
              <p>⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</p>
              <p>⑥ 부영특송은(는) 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.</p>

              <h4>7. 처리하는 개인정보의 항목</h4>
              <p>① &lt;부영특송&gt;('www.02-2614-2222.com'이하 '부영특송')은(는) 다음의 개인정보 항목을 처리하고 있습니다.</p>
              <p>견적문의</p>
              <ul>
                <li>필수항목: 이메일, 휴대전화번호, 이름, 주소, 서비스 이용 기록, 접속 로그, 접속 IP 정보</li>
                <li>선택항목: 회사전화번호, 부서, 회사명, 쿠키</li>
              </ul>

              <h4>8. 개인정보의 파기</h4>
              <p>&lt;부영특송&gt;('부영특송')은(는) 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체 없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.</p>
              <ul>
                <li>파기절차: 이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.</li>
                <li>파기기한: 이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.</li>
                <li>파기방법: 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.</li>
              </ul>

              <h4>9. 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항</h4>
              <p>① 부영특송은 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 쿠키(cookie)를 사용합니다.</p>
              <p>② 쿠키는 웹사이트를 운영하는 데 이용되는 서버가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.</p>
              <ul>
                <li>가. 쿠키의 사용 목적: 이용자가 방문한 각 서비스와 웹사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.</li>
                <li>나. 쿠키의 설치·운영 및 거부: 웹브라우저 상단의 도구 &gt; 인터넷 옵션 &gt; 개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부할 수 있습니다.</li>
                <li>다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</li>
              </ul>

              <h4>10. 개인정보 보호책임자</h4>
              <p>① 부영특송('www.02-2614-2222.com'이하 '부영특송')은(는) 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
              <p>▶ 개인정보 보호책임자</p>
              <ul>
                <li>성명: 이준</li>
                <li>연락처: 02-2614-2222</li>
                <li>이메일: buyoung@gmail.com</li>
              </ul>
              <p>② 정보주체께서는 부영특송('www.02-2614-2222.com'이하 '부영특송')의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 부영특송('www.02-2614-2222.com'이하 '부영특송')은(는) 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.</p>

              <h4>11. 개인정보 처리방침 변경</h4>
              <p>① 이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</p>

              <h4>12. 개인정보의 안전성 확보 조치</h4>
              <p>&lt;부영특송&gt;('부영특송')은(는) 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적·관리적 및 물리적 조치를 하고 있습니다.</p>
              <ul>
                <li>1. 개인정보 취급 직원의 최소화 및 교육: 개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화하여 개인정보를 관리하는 대책을 시행하고 있습니다.</li>
                <li>2. 개인정보의 암호화: 이용자의 비밀번호는 암호화되어 저장 및 관리되고 있으며, 중요한 데이터는 파일 및 전송 데이터를 암호화하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.</li>
              </ul>

              <h4>13. 개인정보 열람청구</h4>
              <p>① 정보주체는 개인정보보호법 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. &lt;부영특송&gt;('www.02-2614-2222.com'이하 '부영특송')은(는) 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.</p>
              <p>▶ 개인정보 열람청구 접수·처리 부서</p>
              <ul>
                <li>담당자: 이준</li>
                <li>연락처: 02-2614-2222</li>
                <li>이메일: buyoung2222@gmail.com</li>
              </ul>
              <p>② 정보주체께서는 제1항의 열람청구 접수·처리부서 이외에, 행정안전부의 개인정보보호 종합지원 포털 웹사이트(<a href="https://www.privacy.go.kr" target="_blank" rel="noopener noreferrer">www.privacy.go.kr</a>)를 통하여서도 개인정보 열람청구를 하실 수 있습니다.</p>
              <p>▶ 행정안전부 개인정보보호 종합지원 포털 → 개인정보 민원 → 개인정보 열람 등 요구 (본인확인을 위하여 아이핀(I-PIN)이 있어야 함)</p>
            </div>
            <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '16px'}}>
              <button onClick={() => setIsPrivacyOpen(false)} style={{padding: '8px 14px', borderRadius: '8px', border: '1px solid #ddd', background: '#f7f7f7', cursor: 'pointer'}}>닫기</button>
            </div>
          </div>
        </div>
      )}

      {/* 정책 팝업 모달 - 이메일 무단수집 거부 */}
      {isEmailPolicyOpen && (
        <div
          className="policy-modal-overlay"
          onClick={() => setIsEmailPolicyOpen(false)}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000
          }}
        >
          <div
            className="policy-modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: '12px', width: '90%', maxWidth: '720px',
              maxHeight: '80vh', overflowY: 'auto', boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
              padding: '24px'
            }}
          >
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px'}}>
              <h3 style={{margin: 0}}>이메일 무단수집 거부</h3>
              <button onClick={() => setIsEmailPolicyOpen(false)} style={{border: 'none', background: 'transparent', fontSize: '20px', cursor: 'pointer'}}>✕</button>
            </div>
            <div style={{fontSize: '14px', color: '#333', lineHeight: 1.6}}>
              <p>본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시 정보통신망법에 의해 형사처벌됨을 유념하시기 바랍니다.</p>
              <p>[게시일 2003년 9일 1일] 이메일을 기술적 장치를 사용하여 무단으로 수집, 판매·유통하거나 이를 이용한 자는 「정보통신망이용촉진 및 정보보호 등에 관한 법률」 제50조의2 규정에 의하여 1천만원 이하의 벌금형에 처해집니다.</p>
              <p>만일, 위와 같은 기술적 장치를 사용한 이메일주소 무단수집 피해를 당하신 경우 「불법스팸대응센터 전용전화(☎1336)나 홈페이지(<a href="http://www.spamcop.or.kr" target="_blank" rel="noopener noreferrer">www.spamcop.or.kr</a>)의 신고창을 통하여 신고하여 주시기 바랍니다.</p>

              <h4>정보통신망법 제50조의2 (전자우편주소의 무단 수집행위 등 금지)</h4>
              <p>① 누구든지 전자우편주소의 수집을 거부하는 의사가 명시된 인터넷 홈페이지에서 자동으로 전자우편주소를 수집하는 프로그램 그 밖의 기술적 장치를 이용하여 전자우편주소를 수집하여서는 아니된다.</p>
              <p>② 누구든지 제1항의 규정을 위반하여 수집된 전자우편주소를 판매·유통 하여서는 아니된다.</p>
              <p>③ 누구든지 제1항 및 제2항의 규정에 의하여 수집·판매 및 유통이 금지된 전자우편주소임을 알고 이를 정보전송에 이용하여서는 아니된다.</p>
            </div>
            <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '16px'}}>
              <button onClick={() => setIsEmailPolicyOpen(false)} style={{padding: '8px 14px', borderRadius: '8px', border: '1px solid #ddd', background: '#f7f7f7', cursor: 'pointer'}}>닫기</button>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>부영특송</h4>
              <p>전국24시화물운송 전문업체</p>
              <p>📞 02)2614-2222</p>
              <p>(24시간 상담-인터넷전화)</p>
              <p>📞 02)2614-2222</p>
              <p>(24시간 상담-지역전화)</p>
              <p>📞 010-4261-2221</p>
              <p>(24시간 상담-회사전화)</p>              
              <p>📧 buyoung2222@gmail.com</p>
            </div>
            <div className="footer-section">
              <h4>주요 서비스</h4>
              <ul>
                <li>일반화물 운송</li>
                <li>택배/소화물</li>
                <li>기업물류</li>
                <li>전국배송</li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>회사 정보</h4>
              <p>설립: 2005년</p>
              <p>본사: 서울특별시 구로구 경인로43길 56, 다동 309호</p>
              <p>사업자등록번호: 117-81-55554</p>
              <p>통신판매업신고: 제2024-서울-0000호</p>
            </div>
            <div className="footer-section">
              <h4>고객센터</h4>
              <p>평일: 24시</p>
              <p>주말/공휴일: 24시</p>
              <p>긴급상황: 24시간 대응</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 부영특송. All rights reserved.</p>
            <div style={{marginTop: '10px', display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
              <button
                type="button"
                onClick={() => setIsPrivacyOpen(true)}
                style={{
                  padding: '8px 12px', borderRadius: '8px', border: '1px solid #ddd', background: '#fff', cursor: 'pointer',
                  fontSize: '13px'
                }}
              >
                개인정보취급방침
              </button>
              <button
                type="button"
                onClick={() => setIsEmailPolicyOpen(true)}
                style={{
                  padding: '8px 12px', borderRadius: '8px', border: '1px solid #ddd', background: '#fff', cursor: 'pointer',
                  fontSize: '13px'
                }}
              >
                이메일무단수집거부
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
